import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../api/firebase";

export default function YaeNoInoriSimpleForm() {
  const [title, setTitle] = useState("");
  const [challenge, setChallenge] = useState("");
  const [gain, setGain] = useState("");
  const [openDate, setOpenDate] = useState("");
  const [step, setStep] = useState("");

  const handleSubmit = async () => {
    if (!title || !challenge || !gain || !openDate || !step) {
      alert("すべての項目を入力してください");
      return;
    }

    const data = {
      title,
      challenge,
      gain,
      openDate: new Date(openDate),
      createdAt: serverTimestamp(),
      step: Number(step),
    };

    try {
      await addDoc(collection(db, "yaeNoInori"), data);
      alert("登録しました！");
      setTitle("");
      setChallenge("");
      setGain("");
      setOpenDate("");
      setStep("");
    } catch (err) {
      console.error(err);
      alert("登録に失敗しました");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h6" gutterBottom>
          🔧 祈りデータ新規登録（シンプル版）
        </Typography>

        <TextField
          fullWidth
          label="タイトル"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          margin="normal"
        />

        <TextField
          fullWidth
          label="チャレンジ内容"
          value={challenge}
          onChange={(e) => setChallenge(e.target.value)}
          margin="normal"
          multiline
          minRows={3}
        />

        <TextField
          fullWidth
          label="得られること（gain）"
          value={gain}
          onChange={(e) => setGain(e.target.value)}
          margin="normal"
          multiline
          minRows={3}
        />

        <TextField
          fullWidth
          label="ステップ番号 (1〜8)"
          value={step}
          onChange={(e) => setStep(e.target.value)}
          margin="normal"
          type="number"
          inputProps={{ min: 1, max: 8 }}
        />

        <TextField
          fullWidth
          label="開放日"
          type="date"
          value={openDate}
          onChange={(e) => setOpenDate(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true, // ラベルが上に固定される
          }}
        />

        <Box textAlign="center" mt={3}>
          <Button variant="contained" onClick={handleSubmit}>
            登録する
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
